import { Box, pxToRem, theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const StyledBox = styled(Box) `
  height: 100%;
  justify-content: space-between;
  flex-direction: column;
  border: ${pxToRem(1)} solid ${theme.semantic.border.default};
  border-radius: ${theme.borderRadius.md};
  box-shadow: ${theme.dropShadow[100]};
  padding: ${theme.spacing.lg};
  gap: ${theme.spacing.md};
`;
